import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { WithCommonTableLogicProps } from '../../../../hoc/withCommonTableLogic';
import { WithViewDataSetHandlerProps } from '../../../../hoc/withViewDataSetHandler';

import { subjectsCardsActions } from '../../../../redux/staticViews/subjectsCards/index';

import Filter from '../../../features/Filter';
import { filterTranslations } from '../../../../settings/i18n/translations/packets';

import { FilterContainer } from '../../../../styles/tabContainers';

const { changeWkdFilter } = subjectsCardsActions;

type MapDispatchToProps = ReturnType<typeof mapDispatchToProps>;

type SingleFilterWKDProps = MapDispatchToProps & WithViewDataSetHandlerProps & RouteComponentProps & WithCommonTableLogicProps;

/**
 *  Komponnet dodający filtry dla nauczciela, który jest z WKD dla łatwiejszego przeglądu tej zakładki
 *
 */
const SingleFilterWKD = ({
  convertDataForFilters,
  openFilterCategory,
  closeFilterCategory,
  selectFilterValues,
  state,
  changeWkdFilter,
}: SingleFilterWKDProps): JSX.Element => {
  const onDataFilter = (value: string, filterData: Array<string>): void => {
    changeWkdFilter('SubjectsCards', filterData[0] === 'true' ? true : false);
    selectFilterValues({
      filterGroupName: value,
      filterValues: filterData,
    });
  };

  return (
    <div>
      <FilterContainer justify='flex-start'>
        <Filter
          filterGroups={convertDataForFilters(state.filters.allFilters)}
          onFilterSelection={openFilterCategory}
          onFilterChange={onDataFilter}
          onFilterDisable={closeFilterCategory}
          translations={filterTranslations}
          loadingFilterList={state.loading}
        />
      </FilterContainer>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  changeWkdFilter: (view: StaticView, isWKD: boolean): void => dispatch(changeWkdFilter(view, isWKD)),
});

export default compose(withRouter, connect(null, mapDispatchToProps))(SingleFilterWKD) as React.ComponentType<any>;
